export default "__VITE_ASSET__DcOZxIP5__"